import { Download } from '@clearkit/icons';
import { CKBox, CKLayoutHorizontal } from 'clearkit';
import { FC } from 'react';

import { SettingsCard } from '~/components/unified/SettingsCard';
import { Invoice } from '~/generated/graphql';

import { GridList } from '../unified/GridList';
import { dollarFormat } from './utils';

type InvoiceListProps = {
  invoices: Invoice[];
};

export const InvoiceList: FC<InvoiceListProps> = ({ invoices }) => {
  return (
    <SettingsCard>
      <SettingsCard.Header>
        <SettingsCard.Heading>Invoices</SettingsCard.Heading>
      </SettingsCard.Header>
      <SettingsCard.Body>
        {invoices.length ? (
          <GridList
            className="py-4 -mx-8"
            gridTemplateColumns="1fr 10rem 6rem 2rem"
          >
            <GridList.Header className="px-8">
              <div>Invoice Period</div>
              <div>Amount</div>
              <div>Status</div>
              <div></div>
            </GridList.Header>
            {invoices.map((invoice) => {
              const invoiceStartDisplay = new Date(
                invoice.startAt,
              ).toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
              });

              const invoiceEndDisplay = new Date(
                invoice.endAt,
              ).toLocaleDateString('en-us', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
              });

              return (
                <GridList.Item
                  className="px-8 py-3 cursor-pointer hover:bg-gray-50"
                  key={`${invoice.id}-$invoice-row`}
                >
                  <div>
                    <a
                      href={`https://dashboard.clearbit.com/invoices/pdf/${invoice.id}`}
                    >
                      {invoiceStartDisplay} to {invoiceEndDisplay}
                    </a>
                  </div>
                  {/* Invoices amounts are stored in cents so need to adjust */}
                  <div>{dollarFormat.format(invoice.amount / 100)}</div>
                  <div>Paid</div>
                  <div>
                    <a
                      href={`https://dashboard.clearbit.com/invoices/pdf/${invoice.id}`}
                      title="Download PDF"
                    >
                      <Download />
                    </a>
                  </div>
                </GridList.Item>
              );
            })}
          </GridList>
        ) : (
          <CKLayoutHorizontal justifyContent="center">
            <CKBox className="p-6 mb-6">No current invoices</CKBox>
          </CKLayoutHorizontal>
        )}
      </SettingsCard.Body>
    </SettingsCard>
  );
};
